module.exports = __webpack_public_path__ + "media/images/logos/rajk-a550c6f722a441a21460ed358e8b709f.svg";